<template>
  <div class="d-flex justify-content-end align-items-center">
    <button
      v-if="shouldShowActionColumn && $can('update-transaction', 'accounting')"
      v-on:click="toggleModal"
      type="button"
      class="mx-4 btn btn-icon"
    >
      <i class="fa fa-sync"></i>
    </button>

    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h5>{{ $t("accounting.label.please_select_transaction_type") }}</h5>
        </div>
        <div class="modal-body">
          <!-- Search input -->
          <input
            type="text"
            v-model="searchQuery"
            placeholder="جست و جو"
            class="form-control mb-3"
          />

          <ul>
            <li v-for="(typeName, typeCode) in filteredTransactionTypes" :key="typeCode">
              <button
                :class="[
                  'btn',
                  'btn-light',
                  { 'btn-selected': selectedType === typeCode },
                ]"
                v-on:click="selectType(typeCode, typeName)"
              >
                {{ typeName }}
              </button>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button v-on:click="toggleModal" class="btn btn-secondary">بستن</button>
          <button
            :disabled="!selectedType"
            v-on:click="submitSelectedType"
            class="btn btn-primary"
          >
            تایید
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  TRANSACTION_TYPES,
  TRANSACTION_TYPES_ACCOUNTING,
  getChargeTransactionTypes,
  getWithdrawalTransactionTypes,
} from "@/constants/accountingTransactionType";
import { i18n } from "@/plugins/i18n";
import { accountingService } from "@/common/api.service";
import { starShopAccountingService } from "../../../common/api.service";

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    },
  },
  data() {
    return {
      selectedType: null,
      showModal: false,
      searchQuery: "",
    };
  },
  computed: {
    activeService() {
      return this.$route.path.includes("pf")
        ? accountingService
        : starShopAccountingService;
    },
    shouldShowActionColumn() {
      const allowedTypes = [
        TRANSACTION_TYPES.chargeOfUnverifiedOrSuspiciousTransaction,
        TRANSACTION_TYPES.chargeOfUnknownOrUnclassifiedTransaction,
        TRANSACTION_TYPES.withdrawOfUnverifiedOrSuspiciousTransaction,
        TRANSACTION_TYPES.withdrawOfUnknownOrUnclassifiedTransaction,
      ];
      return allowedTypes.includes(this.row.t_type_code);
    },
    filteredTransactionTypes() {
      const chargeTypes = getChargeTransactionTypes();
      const withdrawalTypes = getWithdrawalTransactionTypes();
      let types = {};

      if (chargeTypes.includes(this.row.tr_type_code)) {
        types = Object.fromEntries(
          Object.entries(TRANSACTION_TYPES_ACCOUNTING).filter(([key, value]) =>
            chargeTypes.includes(TRANSACTION_TYPES[key])
          )
        );
      } else if (withdrawalTypes.includes(this.row.tr_type_code)) {
        types = Object.fromEntries(
          Object.entries(TRANSACTION_TYPES_ACCOUNTING).filter(([key, value]) =>
            withdrawalTypes.includes(TRANSACTION_TYPES[key])
          )
        );
      } else {
        types = TRANSACTION_TYPES_ACCOUNTING;
      }

      const searchLower = this.searchQuery.toLowerCase();
      return Object.fromEntries(
        Object.entries(types).filter(([key, value]) =>
          value.toLowerCase().includes(searchLower)
        )
      );
    },
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    selectType(typeCode) {
      this.selectedType = typeCode; 
    },
    getTransactionTypeId(transaction_type) {
      return TRANSACTION_TYPES[transaction_type] || null;
    },
    submitSelectedType() {
      if (this.selectedType) {
        const payload = {
          hashid: this.row.id,
          type: this.getTransactionTypeId(this.selectedType),
        };

        if (
          window.confirm(
            i18n.t(
              "accounting.messages.are_you_sure_to_make_this_transaction_type_change"
            )
          )
        ) {
          this.activeService
            .changeTransactionStatus(payload)
            .then(async ({ data }) => {
              await this.datatable.reload();
              this.toastr.success(
                i18n.t("accounting.messages.transaction_status_changed_successfully")
              );
            })
            .catch((error) => {
              const errorMessage =
                error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : i18n.t("accounting.messages.unknown_error");
              this.toastr.error(errorMessage);
            });
        }
        this.selectedType = null;
        this.toggleModal();
      }
    },
  },
});
</script>

<style scoped>
/* Styles for modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  border-radius: 12px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  background: #fff;
}

.modal-header {
  padding: 20px 25px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h5 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #888;
}

.modal-body {
  padding: 15px 25px;
  max-height: 400px;
  overflow-y: auto;
}

.modal-body ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.modal-body li {
  margin-bottom: 10px;
}

.modal-body button {
  display: block;
  width: 100%;
  padding: 10px 15px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  text-align: left;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.modal-body button:hover {
  background: #f0f0f0;
}

.btn-selected {
  background: inherit;
  color: inherit;
}

.modal-footer {
  padding: 15px 25px;
  border-top: 1px solid #e0e0e0;
  text-align: right;
}

.modal-footer .btn-secondary {
  padding: 10px 20px;
  border: none;
  background: #007bff;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
}

.modal-footer .btn-secondary:hover {
  background: #0056b3;
}

.modal-footer .btn-primary {
  padding: 10px 20px;
  border: none;
  background: #28a745;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  margin-left: 10px;
}

.modal-footer .btn-primary:disabled {
  background: #d6d6d6;
  cursor: not-allowed;
}

/* Styles for search input */
.modal-body input[type="text"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.modal-body input[type="text"]::placeholder {
  color: #888;
}
</style>
